import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelector } from '../Auth/authSlice';

const PrivateRoute = ({component: Component, ...rest}) => {

    const {isLoggedIn,user } = useSelector(
        authSelector
      );
      //console.log(user.userType)
    return (
        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isLoggedIn ?
                <Component {...props} />
            : <Redirect to="/login" />
        )} />
    );
};

export default PrivateRoute;